import React, { useContext } from "react"
import { useHistory, useParams } from "react-router-dom"
import { FeatureTypeReferenceSimple } from "../../../../../../api/generated/QuadriConfigurationApi"
import { FeatureCatalogContext } from "../../../../../../features/FeatureCatalogViewer/FeatureCatalogProvider"

const Canvas = (props: { inheritance: FeatureTypeReferenceSimple[]; featureTypeName: string }) => {
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog } = useParams<{ catalog: string; type: string; pid: string }>()

  const textDistance = 75
  const fontSize = 14

  const measure = (text: string) => {
    const newText = document.createElement("text")
    newText.setAttribute("id", "0")
    document.body.appendChild(newText)

    const theTextEle = document.getElementById(`${"0"}`)
    if (theTextEle === null) {
      return
    }
    theTextEle.innerHTML += text

    theTextEle.style.fontFamily = "Verdana"
    theTextEle.style.fontSize = `${fontSize}px`

    const width = theTextEle.getBoundingClientRect().width
    const height = theTextEle.getBoundingClientRect().height

    if (theTextEle.parentNode === null) {
      return
    }
    theTextEle.parentNode.removeChild(theTextEle)

    const dimData = [width, height]

    return dimData
  }

  return (
    <div id="inheritance-tree">
      <svg width={300} height={props.inheritance.length * textDistance - 31} color="red">
        {props.inheritance.map((featureType, i) => {
          if (featureType.featureTypeName === undefined) {
            return
          }
          measure(featureType?.featureTypeName)

          const onClick = () => {
            context.setAtId(null)
            context.setTypeDisplayName(featureType.featureTypeName ?? "")
            context.updateHistory(history, catalog, "featureType", "" + featureType.featureTypeId)
          }

          return (
            <g key={"inheritance-child-" + i}>
              <g key={"inheritance-text-" + i} onClick={onClick} cursor="pointer">
                <rect
                  x="2"
                  y={1 + i * textDistance}
                  height="40"
                  width="50"
                  rx="20"
                  dominantBaseline="middle"
                  textAnchor="middle"
                  strokeWidth="2px"
                  fill="white"
                  stroke={i === props.inheritance.length - 1 ? "#0063a3" : "#d0d0d7"}
                />
                <text
                  x="50%"
                  y={22 + i * textDistance}
                  fontFamily="Verdana"
                  fontSize={`${fontSize}px`}
                  dominantBaseline="middle"
                  textAnchor="middle"
                >
                  {featureType.featureTypeName}
                </text>
              </g>
              <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
                  <polygon fill="#d0d0d7" points="0 1.45, 4 3.45, 0 5.45" />
                </marker>
              </defs>
              <line
                x1="50%"
                y1={75 + i * textDistance}
                x2="50%"
                y2={50 + i * textDistance}
                stroke="#d0d0d7"
                strokeWidth="2"
                markerEnd="url(#arrowhead)"
              />
            </g>
          )
        })}
      </svg>
    </div>
  )
}

export default Canvas
